export default {
	codenames: {
		// Code names are derived from terminology: you name the thing, the generator names the code.
		willBeCalled: "Will be called “{name}”",
		duplicateLabelHint: "another entity already uses this label",
		manualHint: "Set by hand — terminology changes will not rename it.",
		// A name pinned before code names became display-only keeps its pin until released here.
		useDerived: "Derive from the label again",
		/** The pin's name when it can release the name: what it says, then what it does. */
		manualUseDerived: "Set by hand — derive from the label again",
		cleanup: {
			title: "Clean up code names",
			description:
				"Re-derives every code name from its terminology and leaves none set by hand. Anything without terminology gets its code name as the English label. Predefined dataobjects and entities owned by a dependency are never touched.",
			check: "Check for changes",
			apply: "Apply {count} change | Apply {count} changes",
			none: "Every code name follows its terminology, and nothing is set by hand.",
			applied: "Cleaned up {count} entity. | Cleaned up {count} entities.",
			notChecked: "Not checked yet",
			notCheckedHint:
				"Check for changes to see which code names would be renamed, before anything is.",
			notCheckedReadOnly:
				"Someone who can edit this project can check which code names would be renamed.",
			releasesManual: "Set by hand",
			releasesManualHint:
				"The name was set by hand. The clean-up releases it, so terminology changes rename it again.",
			createsTerm: "New term",
			createsTermHint:
				"It has no terminology yet. The clean-up adds a term with this code name as its English label, marked as not yet verified.",
			kinds: {
				dataobject: "Dataobjects",
				type: "Types",
				attribute: "Attributes",
				relation: "Relations",
				type_value: "Type values",
			},
		},
	},
};
